import { render, staticRenderFns } from "./PhotoMore.vue?vue&type=template&id=563f8e0a&scoped=true"
import script from "./PhotoMore.vue?vue&type=script&lang=js"
export * from "./PhotoMore.vue?vue&type=script&lang=js"
import style0 from "./PhotoMore.vue?vue&type=style&index=0&id=563f8e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f8e0a",
  null
  
)

export default component.exports